<template>
	<div>
		<!-- claim particulars -->
		<template>
			<div>
				<div class="flex xs-12 mb2 xs-middle" slot="headline">
					<div class="flex xs-6 xs-left fs5 lh125 fw7 c1">
						{{ $t("particulars") }}
					</div>
					<div class="flex xs-6 xs-right xs-middle lh125 c1">
						<j-button 
              v-if="canEditApprovedClaims(claim.status)"
              type="tertiary" 
              @click="$modal.show('updateParticulars')"
            >
							<crm-icon name="edit" size="small" color="c2" />
							{{ $t("update") }}
						</j-button>
					</div>
				</div>
				<!-- Items -->
				<j-card class="bg5">
					<j-list :list="computedParticulars">
						<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
							<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
								{{ item.label }}
							</div>
							<div class="flex xs-6 xs-left xs-middle lh125">
								<router-link :to="item.link" v-if="item.link">
									{{ item.value }}
								</router-link>
								<template v-else-if="item.type === 'status'">
									<j-tag
										:label="$t(item.value)"
										:variant="decideStatusStyle(item.value)"
									/>
								</template>
								<template v-else>{{ item.value }}</template>
							</div>
						</div>
					</j-list>
					<div class="bg5 ta2 fs3 p2" v-if="computedParticulars.length === 0">
						{{ $t("errors.no_data") }}
					</div>
				</j-card>

				<!-- Update Modal -->
				<core-modal
					name="updateParticulars"
					:headline="$t('update_particulars')"
				>
					<update-particulars
						:data="particularsToUpdate"
						@updated="$emit('updated')"
					/>
				</core-modal>
			</div>
		</template>
	</div>
</template>

<script>
import UpdateParticulars from "./UpdateParticulars"
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import JTag from "@/components/JTag/"
import { canEditApprovedClaims } from "../utils/"

export default {
	components: {
		UpdateParticulars,
		CoreModal,
		CrmIcon,
		JButton,
		JCard,
		JList,
		JTag
	},
	props: {
		claim: {
			required: true
		}
	},
	computed: {
		computedParticulars() {
			return [
				{
					label: this.$t("status"),
					value: this.claim.status,
					type: "status"
				},
				{
					label: this.$t("claim_number"),
					value: this.claim?.issuerNumber
				},
				// {
				// 	label: this.$t("claimant"),
				// 	value: this.claim.claimant?.name,
				// 	link: this.claim.claimant?.name
				// 		? `/${this.$store.tenantId}/clients/detail/${this.claim?.claimant?.id}/overview/individual`
				// 		: null
				// },
				{
					label: this.$t("policy_number"),
					value: this.claim.policy?.issuerNumber,
					link: this.claim.policy?.id
						? `/${this.$store.state.tenantId}/policies/detail/policy/${this.claim.policy.id}`
						: null
				}
			]
		},

		particularsToUpdate() {
			return {
				claimId: this.claim?.id,
				claimantId: null,
				policyId: this.claim?.policy?.id,
				status: this.claim?.status
			}
    }
	},

	methods: {
		decideStatusStyle(status) {
			if (!status) return

			const errorStatuses = ["REJECTED"]
			const successStatuses = ["APPROVED"]
      const warningStatuses = ["PROCESSING", "---"]
      const neutralStatuses = ["PENDING"]
			if (errorStatuses.find(item => item === status.toUpperCase()))
				return "error"
			if (successStatuses.find(item => item === status.toUpperCase()))
				return "success"
			if (warningStatuses.find(item => item === status.toUpperCase()))
				return "warning"
			if (neutralStatuses.find(item => item === status.toUpperCase()))
				return "neutral"
    },

    canEditApprovedClaims: canEditApprovedClaims
  }
}
</script>
